export const getCurrencies = (state) => state.currencies